import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import {
  MAT_DIALOG_DATA,  
  MatDialogModule  
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'nova-info-dialog',
  standalone: true,
  imports: [MatIconModule,
    MatDialogModule,
    MatButtonModule
  ],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string, label: string, body: string[] }) { }
}
